module.exports = __webpack_public_path__ + "static/media/Digital-HR-Strategy.c11a3b5b.png";